import { getLocation, getQueryParams } from '@office-start/url-parser-utility';
export var getCampainIdFromTargetUrl = function (url) {
    if (url && url.indexOf('ocid=') > 0) {
        var location_1 = getLocation(url);
        if (location_1) {
            var params = getQueryParams(location_1.search);
            return params['ocid'] !== '' ? params['ocid'] : 'PROD_OfficeCom';
        }
    }
    return 'PROD_OfficeCom';
};
//# sourceMappingURL=getCampainIdFromTargetUrl.js.map